import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import Menu from '../components/menu'
import ImageGenerated from '../components/image-generated'
import { doubleQueryFirestore } from "../config/firestore";
import { Link } from 'react-router-dom';
import './home.css'

const Home = (props) => {
  const {user} = props;
  const [photoUrl, setPhotoUrl] = useState('');
  const [emotion, setEmotion] = useState('');
  const [phrase, setPhrase] = useState('');
  const [image, setImage] = useState('');
  const [created, setIsCreated] = useState(false);

  useEffect(() => {
    const date = new Date()
    const findCreated = async () => {
      const response = await doubleQueryFirestore('userEmotion', 'month',  date.getMonth(), 'day',  date.getDate(), user.uid)
      if (response && response.docs[0]) {
        const data = response.docs[0].data()
        if (data) {
          setPhrase(data.phrase);
          setImage(data.image);
          setEmotion(data.emotion);
          setPhotoUrl(data.photoUrl);
          setIsCreated(true);
        }
      }
    }
    findCreated()
  }, [])


  return (
    <div className="home-container">
      <Helmet>
        <title>Hackathon</title>
        <meta property="og:title" content="Hackathon" />
      </Helmet>

      {created ? (
        <ImageGenerated
          rootClassName="image-generated-root-class-name"
          heading={phrase}
          image_background={image}
          emotion={emotion}
          photoUrl={photoUrl}
        />
      ) : (
        <div className="home-container1">
          <h1 className="home-text">
          <span>Generate Your</span>
          <br></br>
          <span>Daily Phrase</span>
          <br />
          <br />
          <button className='button accept'>
            <Link to={"/Login"}>{!user.uid && "Enter Now"}</Link>
          </button>
        </h1>
        </div>
      )}
      <Menu 
        user={user} 
        rootClassName="menu-root-class-name" 
        created={created} 
      />
    </div>
  )
}

export default Home
